const fieldClass =
  'h-7 w-full rounded-full border border-gray-300 px-3 py-1 text-[11px] font-medium leading-tight focus:outline-none'

const FiltrosProvisionAgenteAduana = ({
  filters,
  documentOptions,
  onFilterChange
}) => (
  <div className='rounded-3xl border border-gray-200 bg-white p-4 shadow-sm'>
    <div className='flex items-start gap-3'>
      <div className='min-w-0 flex-1'>
        <div className='flex flex-wrap items-end gap-3'>
            <div className='min-w-[145px] flex-1'>
              <label className='mb-1 block text-[11px] font-medium'>Fecha Desde</label>
              <input
                type='date'
                value={filters.fechaInicio}
                onChange={event => onFilterChange('fechaInicio', event.target.value)}
                className={fieldClass}
              />
            </div>
            <div className='min-w-[145px] flex-1'>
              <label className='mb-1 block text-[11px] font-medium'>Fecha Hasta</label>
              <input
                type='date'
                value={filters.fechaFin}
                onChange={event => onFilterChange('fechaFin', event.target.value)}
                className={fieldClass}
              />
            </div>
            <div className='min-w-[180px] flex-[1.2]'>
              <label className='mb-1 block text-[11px] font-medium'>Documento</label>
              <select
                value={filters.documento}
                onChange={event => onFilterChange('documento', event.target.value)}
                className={fieldClass}
              >
                <option value=''>Todos</option>
                {documentOptions.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            <div className='min-w-[180px] flex-[1.4]'>
              <label className='mb-1 block text-[11px] font-medium'>Palabra Clave</label>
              <input
                type='text'
                value={filters.keyword}
                onChange={event => onFilterChange('keyword', event.target.value)}
                placeholder='Buscar documento, proveedor o cuenta'
                className={fieldClass}
              />
            </div>
            <label className='inline-flex h-7 cursor-pointer items-center gap-2 whitespace-nowrap text-[11px] font-medium'>
              <input
                type='checkbox'
                checked={filters.montosSimilares}
                onChange={event => onFilterChange('montosSimilares', event.target.checked)}
                className='rounded'
              />
              Montos Similares
            </label>
        </div>

      </div>

    </div>
  </div>
)

export default FiltrosProvisionAgenteAduana
